module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-12.d7f05ce4.jpg";